import React from 'react';
import { useTranslation } from 'react-i18next';

import { Alert, Box } from '@chargify/custom-ui-components';
import { List } from './PaymentProfilesReplace.styles';

type Props = {
  subscriptions: {
    success: { id: number; product: { name: string } }[];
    failed: { id: number; product: { name: string } }[];
  };
  onRetry: () => void;
};

export const PaymentProfilesReplaceAlerts = ({
  subscriptions,
  onRetry,
}: Props) => {
  const { success, failed } = subscriptions;
  const { t } = useTranslation(['subscriptions-manager', 'common']);
  return (
    <>
      <Box marginBottom={6}>
        {success && (
          <Alert color={'primary'}>
            <Alert.TextMessage>
              {t('payment_profile.successful_replacement_for')}
            </Alert.TextMessage>
            <List mb={0} mt={1}>
              {success.map((subscription) => (
                <li key={subscription.id}>{subscription.product.name}</li>
              ))}
            </List>
          </Alert>
        )}
      </Box>
      <Alert
        color={'danger'}
        buttonLabel={t('retry', {
          ns: 'common',
        })}
        onClick={onRetry}
      >
        <Alert.TextMessage>
          {t('payment_profile.failed_replacement_for')}
        </Alert.TextMessage>
        <List mb={6} mt={1}>
          {failed.map((subscription) => (
            <li key={subscription.id}>{subscription.product.name}</li>
          ))}
        </List>
        <Alert.TextMessage>
          {t('payment_profile.retry_or_update_manually')}
        </Alert.TextMessage>
      </Alert>
    </>
  );
};
